import {
  ADD_COURSES_DIALOG,
  ADD_COURSE_MODAL_SCROLL_RESTORED,
  COURSE_ITEM_CHANGE,
  COURSE_RESET_DATA,
  SET_ADD_COURSE_MODAL_SCROLL,
} from './types';

const initialState = {
  addCoursesDialogOpen: false,
  coursesItem: {},
  addCourseModalScrollTop: 0,
  addCourseModalScrollRestoreCount: 0,
  addCourseModalScrollModuleIndex: null,
};

const onlineCourses = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COURSES_DIALOG:
      return {
        ...state,
        addCoursesDialogOpen: action.payload,
        // Clear scroll restoration when dialog closes
        ...(action.payload === false && {
          addCourseModalScrollTop: 0,
          addCourseModalScrollRestoreCount: 0,
          addCourseModalScrollModuleIndex: null,
        }),
      };
    case COURSE_ITEM_CHANGE:
      return {
        ...state,
        coursesItem: action.payload,
      };
    case COURSE_RESET_DATA:
      return initialState;
    case SET_ADD_COURSE_MODAL_SCROLL: {
      const { scrollTop, restoreCount, moduleIndex } = action.payload;
      return {
        ...state,
        addCourseModalScrollTop: scrollTop,
        addCourseModalScrollRestoreCount:
          restoreCount !== undefined && restoreCount !== null
            ? restoreCount
            : 5,
        addCourseModalScrollModuleIndex:
          moduleIndex !== undefined && moduleIndex !== null ? moduleIndex : null,
      };
    }
    case ADD_COURSE_MODAL_SCROLL_RESTORED: {
      const nextCount = Math.max(
        0,
        (state.addCourseModalScrollRestoreCount != null
          ? state.addCourseModalScrollRestoreCount
          : 0) - 1,
      );
      return {
        ...state,
        addCourseModalScrollRestoreCount: nextCount,
        ...(nextCount === 0
          ? { addCourseModalScrollTop: 0, addCourseModalScrollModuleIndex: null }
          : {}),
      };
    }
    default:
      return state;
  }
};

export default onlineCourses;
